"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 36 36" },
  React.createElement("path", { d: "M30 2H10.987a.37.37 0 0 0-.259.635l5.848 5.718a40.092 40.092 0 0 0-6.94 10.026C6.1 25.993 7.324 33.461 8.032 33.43c2.036-.089 1.161-2.545 2.49-5.312a31.227 31.227 0 0 1 12.794-13.176l6.055 5.921A.37.37 0 0 0 30 20.6z" })
);

